module.exports = __webpack_public_path__ + "assets/img/reminder-share-1.0cec4ecb.png";